// libs
import { styled } from '@nykaa/ui-components';
import { keyframes } from '@emotion/core';
import { OVERLAY_ZINDEX } from 'shared/styles/base';

const slideInOut = keyframes`
  from {
    transform: translateY(200%);
    opacity: 0;
  }

  9% {
    transform: translateY(0);
    opacity: 1;
  }

  92% {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(200%);
    opacity: 0;
  }
`;

export const Container = styled.div<{ animationTime: number; }>`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing.spacing60} ${theme.spacing.spacing60}`};

  background: ${({ theme }) => theme.colors.surfaceInverse};
  box-shadow: ${({ theme }) => theme.elevations.shadow400};
  border-radius: ${({ theme }) => theme.borders.radius10};

  position: fixed;
  bottom: calc(var(--cart-cta-height) + var(--base-gutter));
  left: var(--base-gutter);
  right: var(--base-gutter);
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textInversePrimary};
  max-width: 360px;
  margin: 0 auto;
  z-index: ${OVERLAY_ZINDEX + 2};
  animation: ${slideInOut} ${({ animationTime }) => animationTime}s ease-in-out forwards;
`;

export const Action = styled.button`
  ${({ theme }) => theme.typography.buttonMedium};
  border: 0;
  background: transparent;
  ${({ theme }) => `
    color: ${theme.colors.surface};
    margin: -${theme.spacing.spacing40} 0 -${theme.spacing.spacing40} auto;
    padding: 0 0 0 ${theme.spacing.spacing40};
  `};
  height: 40px;
  outline: none;
`;
